import { render, staticRenderFns } from "./AdminHistoryShow.vue?vue&type=template&id=2a36aadd&"
import script from "./AdminHistoryShow.vue?vue&type=script&lang=js&"
export * from "./AdminHistoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports